export enum AppRateDischarge {
  'Погано' = 1,
  'Незадовільно',
  'Задовільно',
  'Добре',
  'Відмінно'
}
